import { connect } from 'react-redux';
import { NUMBER_OF_SUBGRADE_STORIES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import StoriesFieldSet from './StoriesFieldSet.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormFieldVisibility } = modelTypesByForm[form];
  return {
    showSubgradeStories: selectFormFieldVisibility(state)(NUMBER_OF_SUBGRADE_STORIES),
  };
};

export default connect(mapStateToProps)(StoriesFieldSet);
